var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#4DAE01","strokeWidth":"1.5","d":"M1 6.455 6.6 11 15 1"}));
}

Check.defaultProps = {"fill":"none","viewBox":"0 0 16 13"};

module.exports = Check;

Check.default = Check;
